<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-button modal-button-outline" @click="$emit('cancel')">
                <slot name="cancel">Cancel</slot>
              </button>
              <button v-if="showAccept" style="margin-left: 24px" class="modal-button modal-button-primary" @click="$emit('accept')">
                <slot name="accept">Accept</slot>
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 500px;
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  padding: 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-footer{
  padding-left: 0;
  padding-right: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-button{
  font-weight: 700;
  font-size: 16px;
  line-height: 175%;
  padding: 4px 16px;
  border: 2px solid #E12A12;
  border-radius: 6px;
  transition: 0.3s;
}

.modal-button-primary{
  color: #fff;
  background-color: #E12A12;
}

.modal-button-primary:hover{
  color: #E12A12;
  background-color: #fff;
}

.modal-button-outline{
  color: #E12A12;
  background-color: #fff;
}

.modal-button-outline:hover{
  color: #fff;
  background-color: #E12A12;
}

</style>

<script>

export default {
  props: {
    showAccept: Boolean,
  },
  data: () => ({

  }),
}
</script>
